export default function CurrencyFormat(props) {
  const { amount, currency } = props;
  const formattedCurrency = new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount);

  return formattedCurrency;
}
